import { CSSProperties } from 'react';

import { AppColors } from '../../theme';

type PaginationControlStyles = {
  container: CSSProperties;
  itemContainer: CSSProperties;
  itemText: CSSProperties;
  inactivePageItem?: CSSProperties;
  activePageItem: CSSProperties;
  navigationItem: CSSProperties;
  jumpNavigationItem: CSSProperties;
  itemSelect: CSSProperties;
};

const styles: PaginationControlStyles = {
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginTop: '4rem',
    flexWrap: 'wrap',
    gap: '16px',
    width: '100%'
  },
  itemContainer: {
    alignItems: 'center',
    gap: '8px'
  },
  itemText: {
    color: AppColors.VA.NEUTRALS._90_,
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '22px'
  },
  inactivePageItem: {
    border: `1px solid ${AppColors.VA.NEUTRALS._30_}`,
    borderRadius: '4px',
    height: '2.1rem',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  activePageItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '5rem',
    color: AppColors.VA.NEUTRALS.WHITE
  },
  navigationItem: {
    color: AppColors.VA.NEUTRALS._90_,
    fontSize: '20px',
    fontWeight: '100'
  },
  jumpNavigationItem: {
    color: AppColors.VA.PRIMARY._50_,
    fontSize: '20px',
    fontWeight: '100'
  },
  itemSelect: {
    width: 70,
    height: 38,
    marginLeft: '1rem',
    border: `1px solid ${AppColors.VA.BACKGROUND._30_}`,
    borderRadius: '6px'
  }
};

export default styles;
